const BASE = process.env.REACT_APP_BACKEND_URL;

export const assistantApi = {
  chat: ({ session_id, message, context }) =>
    fetch(`${BASE}/api/kb/assistant`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id, message, context }),
    }).then(async (r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    }),
};
